import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface BookCoverProps {
  onStartReading: () => void;
}
export function BookCover({
  onStartReading
}: BookCoverProps) {
  return <div className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-forest px-6 text-center" data-id="element-18">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-20" data-id="element-19">
        <div className="absolute -left-[20%] -top-[10%] h-[70%] w-[70%] rounded-full bg-gold blur-[120px]" data-id="element-20" />
        <div className="absolute -bottom-[20%] -right-[10%] h-[60%] w-[60%] rounded-full bg-sage blur-[100px]" data-id="element-21" />
      </div>

      <div className="relative z-10 flex max-w-3xl flex-col items-center" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-23">
          <span className="mb-6 inline-block rounded-full border border-gold/30 bg-gold/10 px-4 py-1.5 font-sans text-sm font-medium tracking-widest text-gold uppercase" data-id="element-24">
            Edición Exclusiva
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="mb-6 font-serif text-5xl font-medium leading-tight text-cream md:text-7xl" data-id="element-25">
          Protocolo Anti-Inflamatorio{' '}
          <span className="text-gold italic" data-id="element-26">65+</span>
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="mb-8 font-sans text-xl font-light text-cream/90 md:text-3xl" data-id="element-27">
          El Método de Micro-Cocina de 10 Minutos para Recuperar tu Movilidad
        </motion.h2>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mb-12 max-w-xl font-serif text-lg text-cream/70 md:text-xl" data-id="element-28">
          Dile adiós a la rigidez matutina y vuelve a disfrutar de cada paso.
          Preparado exclusivamente para la mujer que decide no aceptar el dolor
          como parte de su edad.
        </motion.p>

        <motion.button initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} onClick={onStartReading} className="group flex items-center gap-3 rounded-full bg-gold px-8 py-4 font-sans text-lg font-semibold text-forest transition-all hover:bg-white hover:shadow-lg hover:shadow-gold/20" data-id="element-29">
          Comenzar a leer
          <ChevronDown className="h-5 w-5 transition-transform group-hover:translate-y-1" data-id="element-30" />
        </motion.button>
      </div>
    </div>;
}